import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { BreadcrumbService } from '@suvo/frontend/standalone/breadcrumb';
import { IMicroscope } from '../interface/microscope.interface';
import { MicroscopeService } from '../service/microscope.service';

@Injectable({ providedIn: 'root' })
export class MicroscopeResolver implements Resolve<IMicroscope> {
  constructor(
    private readonly microscopes: MicroscopeService,
    private readonly breadcrumb: BreadcrumbService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<IMicroscope> {
    const microscope = await this.microscopes.getOne('', route.params['id']);
    this.breadcrumb.setDynamicNameSwap('microscope', microscope.oldMicroscopeId.toString());
    return microscope;
  }
}
